import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import $ from "jquery";

new Vue({
  render: h => h(App),
  mounted(){
    //判断横屏竖屏
    function orientationChange() {

      switch(window.orientation) {
      case -90: 
      case 90: 
        setTimeout(function(){resize()},200)    
        break;
      case 0:
      case 180:
        setTimeout(function(){resize()},200)
        break;
      }};
  
      window.onorientationchange =orientationChange;
      window.onresize =orientationChange;
  
      function resize() {
        var body = document.getElementsByTagName('body')[0];
        var html = document.getElementsByTagName('html')[0];
        var width = $(window).width();
        var height = $(window).height();

        let max=0
        let min=0
      
        if(width<height){
          max=height
          min=width
          $('.wrapper').css({'width':width+'px','height':height+'px'})
          $('.swiper').css({'width':width+'px','height':height+'px'})
        }else{
          max=width
          min=height
          $('.wrapper').css({'width':height+'px','height':width+'px'})
          $('.swiper').css({'width':height+'px','height':width+'px'})
        }

        //优化画布
        let level=1206
        //alert(max*2)
        if(max*2>level){
          $('#mypageKV canvas').css({'height':'100%'})
        }else{
          let dur=Math.abs((1380-max*2)/4)

          let yy=1380/750*min
          $('#mypageKV').css({'transform':'translate(0,-'+dur+'px)','height':yy+'px'})

          

        }
      }
  
      resize();
  }
}).$mount('#app')
